import { NgModule } from '@angular/core';
import { ModalModule, PaginationModule, TooltipModule } from '@dignity-health/ngx-components';

@NgModule({
  imports: [ModalModule, PaginationModule, TooltipModule],
  exports: [ModalModule, PaginationModule, TooltipModule]
})
export class DignityHealthComponentsModule {}
